export class DriverAbsenceType {
  id: number = -1;

  name: string = '';

  createdAt: string = '';
  updatedAt: string = '';
}
